<mat-card [class.mat-elevation-z1]="'true'">
  <div class="card-spacer">
    <div *ngIf="!hasCustomerRole" class="gobackmobile" style="    text-align: right;
    position: absolute;
    z-index:30;
    right: 15px;"> <button class="mat-raised-button back-button" (click)="goBack()">Back</button></div>
    <div> <button class="mat-raised-button back-button" (click)="goBack()">Back</button></div>
    <mat-tab-group class="table-container">
      <mat-tab label="Shipment Details">
        <div class="details-container" *ngIf="detail">
          <table class="details-table">
            <tr><th class="header-column">AMCO ID</th><td>{{ detail.amcoId }}</td></tr>
            <tr><th class="header-column">Consignment Number     </th><td>{{ detail.consignmentNumber }}</td></tr>
            <tr><th class="header-column">Transport Order Number  </th><td>{{ detail.transportOrderNumber }}</td></tr>
            <tr><th class="header-column">Order Date             </th><td>{{ detail.orderdate }}</td></tr>
            <tr><th class="header-column">Department</th><td>{{ detail.departmentName }}</td></tr>
            <tr><th class="header-column">Owning User</th><td>{{detail.owningUser}}</td></tr>
            <tr><th class="header-column">Order Type             </th><td>{{ detail.orderType }}</td></tr>
            <tr><th class="header-column">Shipment Mode</th><td>{{detail.shipmentMode}}</td></tr>
            <tr><th class="header-column">Special Instructions</th><td>{{ detail.note }}</td></tr>
            <tr><th class="header-column">Customer</th><td>{{ detail.customerName }} - {{detail.destination}}</td></tr>
            <tr><th class="header-column">Customer Contact</th><td>{{ detail.customerContact }}</td></tr>
            <tr><th class="header-column">PO Number</th><td>{{ detail.poNumber }}</td></tr>
            <tr><th class="header-column">Collection Address  </th><td>{{ detail.senderName }} - {{detail.collectionAddress}}</td></tr>
            <tr><th class="header-column">Planned Loading Start   </th><td>{{ detail.plannedLoadingStart  | date: 'dd-MMM-yyyy HH:mm':'UTC'  }}</td></tr>
            <tr><th class="header-column">Planned Loading End     </th><td>{{ detail.plannedLoadingEnd  | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
            <tr><th class="header-column">Delivery Address                  </th><td>{{ detail.name }} - {{detail.destination}}</td></tr>
            <tr><th class="header-column">Planned Delivery Start  </th><td>{{ detail.plannedDeliveryStart  | date: 'dd-MMM-yyyy HH:mm':'UTC'  }}</td></tr>
            <tr><th class="header-column">Planned Delivery End    </th><td>{{ detail.plannedDeliveryEnd  | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
            <tr><th class="header-column">Assigned Vehicle</th><td>{{ detail.regNumber }}</td></tr>
            <tr><th class="header-column">Tracking Url</th><td><a href="{{ detail.trackingUrl }}" target="_blank">{{ detail.trackingUrl }}</a></td></tr>
            <tr><th class="header-column">Customs Agent           </th><td>{{ detail.customsAgent }}</td></tr>
            <tr><th class="header-column">Planned Time</th><td>{{ detail.targetDateTime | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
            <tr><th class="header-column">Latest ETA</th><td>{{ detail.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'  }}</td></tr>
            <tr><th class="header-column">Last Modified</th><td>{{ detail.lastModifiedDate | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
            <tr><th class="header-column">Last Action Date</th><td>{{ detail.lastActionDate | date: 'dd-MMM-yyyy HH:mm' }}</td></tr>
            <tr><th class="header-column">Last Action</th><td>{{ detail.latestAction }}</td></tr>
<!--

                <tr><th class="header-column">Customer Number        </th><td>{{ detail.customerNumber }}</td></tr>
                <tr><th class="header-column">Total Sales In GBP       </th><td>{{ detail.totalSalesInGBP }}</td></tr>
                <tr><th class="header-column">Receiver Country       </th><td>{{ detail.receiverCountry }}</td></tr>
                <tr><th class="header-column">Receiver Name          </th><td>{{ detail.receiverName }}</td></tr>
                <tr><th class="header-column">Receiver City          </th><td>{{ detail.receiverCity }}</td></tr>
                <tr><th class="header-column">Sender Country         </th><td>{{ detail.senderCountry }}</td></tr>
                <tr><th class="header-column">Sender Name            </th><td>{{ detail.senderName }}</td></tr>
                <tr><th class="header-column">Sender City            </th><td>{{ detail.senderCity }}</td></tr>

                <tr><th class="header-column">Collection Address            </th><td>{{ detail.collectionAddress }}</td></tr>


                <tr><th class="header-column">Delivery Address</th><td>{{ detail.destination }}</td></tr>
                <tr><th class="header-column">Type</th><td>{{ detail.typeName }}</td></tr> -->
                <!-- </tr> -->
              </table>
            </div>
        </mat-tab>
        <!--Vehicle history tab-->
        <mat-tab label="Vehicle History" *ngIf="false">
            <table class="tgrey" mat-table matSort [dataSource]="dataSource" style="width: 100%;" class="details-table">

                <ng-container matColumnDef="positionDateTime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column">
                        Position DateTime</th>
                    <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                        {{ element.positionDateTime | date: 'medium' }}</td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                        Address</th>
                    <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                        {{ element.addressInfo}}</td>
                </ng-container>

                <ng-container matColumnDef="countryCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                        Country Code</th>
                    <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                        {{element.countryCode}}</td>
                </ng-container>

                <ng-container matColumnDef="zipCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                        Zip Code</th>
                    <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                        {{element.zipCode}}</td>
                </ng-container>

                <ng-container matColumnDef="nearestCity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                        Nearest City</th>
                    <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                        {{element.nearestCity}}</td>
                </ng-container>

                <ng-container matColumnDef="isManual">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-column" >
                        Manual Input</th>
                    <td style="text-align: left;padding: 10px;padding-left: 10px !important;" mat-cell *matCellDef="let element">
                        {{element.isManual === true ? "Yes": "No"}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="dataSourceConfig.columns"></tr>
                <tr mat-row *matRowDef="let row; columns: dataSourceConfig.columns"></tr>

            </table>
            <div class="card-spacer">
                <mat-paginator (page)="page($event)" [pageSizeOptions]="dataSourceConfig.pageSizeOptions"
                    showFirstLastButtons></mat-paginator>
            </div>
        </mat-tab>
        <!-- Map Tab -->
        <mat-tab label="Map">
            <ng-template matTabContent>
            <div style="  height: 66vh;" class="map-container">
            <agm-map [latitude]="lat" [longitude]="lng" [zoom]="5" (mapReady)="onMapReady($event)">
                 <!--Destination maker-->
                <agm-marker [latitude]="lat" [longitude]="lng" [title]="detail?.destination" [draggable]="false"
                    [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm')"
                    [iconUrl]="{ url:getIcon('Delivery',detail?.updateBy),scaledSize: {width: 45,height: 60}}"
                    >
                    <agm-info-window>
                        <strong>Destination: {{detail?.destination}}</strong>
                    </agm-info-window>
                </agm-marker>
                 <!--Vehicle maker-->
                <agm-marker *ngIf="(vehicleDet?.positionDateTime !== undefined || vehicleDet?.positionDateTime !== null)" [latitude]="vehicleDet?.latitude" [longitude]="vehicleDet?.longitude" matTooltip="text"
                        [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm')"
                        [draggable]="false"
                        [iconUrl]="{url: getTruckIcon((detail?.type === 'Collection' ? detail?.plannedLoadingEnd : detail?.plannedDeliveryEnd), detail?.estimatedDateTime, (detail?.type === 'Collection' ? detail?.actualCollectionDate : detail?.actualDeliveryDate)), scaledSize: {width: 45,height: 55}}">
                    <agm-info-window>
                        <strong>Reg Nr: {{vehicleDet?.vehicleLicensePlate}}</strong><br>
                        <strong>Position Date: {{vehicleDet?.positionDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                        <strong>Next location: {{detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination}}</strong><br>
                        <strong>ETA: {{detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                    </agm-info-window>
                </agm-marker>
                <!--Collection maker-->
                <agm-marker [latitude]="collectionLat" [longitude]="collectionLng" [draggable]="false"
                    [title]="'Next location: ' + (detail?.type === 'Collection' ? detail?.collectionAddress : detail?.destination) + '\nETA: ' + (detail?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm')"
                    [iconUrl]="{url:getIcon('Collection',detail?.updateBy), scaledSize: {width: 45,height: 60}}"

                    >
                    <agm-info-window>
                        <strong>Collection: {{detail?.collectionAddress}}</strong>
                    </agm-info-window>
                </agm-marker>
                <agm-marker
                    *ngFor="let event of vehicleEventMarkers"
                    [latitude]="event.latitude"
                    [longitude]="event.longitude"
                    [title]="getVehicleEventTitle(event)"
                    [iconUrl]="{ url: 'assets/images/amco-green-truck.png', scaledSize: { width: 35, height: 45 } }">
                    <agm-info-window>
                        <div>
                            <strong>Reg:</strong> {{ event.vehicleLicensePlate }}<br>
                            <strong>Date:</strong> {{ event.positionDateTime | date: 'dd-MMM-yyyy HH:mm' }}<br>
                            <strong>City:</strong> {{ event.nearestCity }}<br>
                            <strong>Address:</strong> {{ event.addressInfo }}
                        </div>
                    </agm-info-window>
                </agm-marker>
                <agm-polyline
                    *ngIf="vehicleEventPolylinePoints.length > 1"
                    [strokeColor]="'#15457e'"
                    [strokeWeight]="2"
                    [editable]="false"
                    [visible]="true">
                    <agm-polyline-point
                        *ngFor="let point of vehicleEventPolylinePoints"
                        [latitude]="point.lat"
                        [longitude]="point.lng">
                    </agm-polyline-point>
                </agm-polyline>
                 <!--Blue/Google/Route Line
                <agm-polyline [strokeColor]="'blue'" [strokeWeight]="2" [editable]="false" [visible]="true" >
                    <agm-polyline-point *ngFor="let s of polylinePoints; let i=index;" [latitude]="s.lat"
                        [longitude]="s.lng">

                    </agm-polyline-point>
                </agm-polyline> -->

                <!--Red/Google/Route Line
                <agm-polyline [strokeColor]="'#15457e'" [strokeWeight]="2" [editable]="false" [visible]="true" >
                    <agm-polyline-point *ngFor="let s of redPolylinePoints; let i=index;" [latitude]="s.lat"
                        [longitude]="s.lng">

                    </agm-polyline-point>
                </agm-polyline> -->

            </agm-map>
          </div>
                    </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
</mat-card>
